import PropTypes from 'prop-types';
import React from 'react';
import WindowResizeListener from 'common/components/WindowResizeListener';

class Breakpoint extends React.PureComponent {
  static displayName = 'Breakpoint';

  static propTypes = {
    children: PropTypes.func,
    maxWidth: PropTypes.number,
  };

  state = {pass: true};

  _handleResize = ({windowWidth}) => {
    this.setState({pass: windowWidth <= this.props.maxWidth});
  };

  render() {
    return (
      <div style={{height: 'inherit'}}>
        {this.props.children(this.state.pass)}
        <WindowResizeListener onResize={this._handleResize} />
      </div>
    );
  }
}

export default Breakpoint;



// WEBPACK FOOTER //
// ./src/ondemand/components/Breakpoint.js